import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Booklist = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },
        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/staff.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Book List 2025-26" breadEnd="Book List" breadMid="Book List 2025-26" />
                       
                        </div>
                    </div>
                    <div class="text-box pdfContainer">
                    <ul>
                                    <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/BOOKLIST-FS-1-III-(2025-26).pdf">
                                  fs 1
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist-IV-VIII.pdf">
                                Grade IV-VIII  
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/GRADE-IX- XII-(2025-26).pdf">
                                Grade IX- XII  
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                         
                            </ul>
                    </div>

                    <div className="row">
                        <div className="col-md-12"> <div className="page-title">
        <h1>Book List 2024-25</h1>
        </div>
                        </div>
                    </div>
                    <div class="text-box pdfContainer">
                    <ul>
                                    <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist1.pdf">
                                    Grade 1
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist2.pdf">
                                    Grade 2
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist3.pdf">
                                    Grade 3
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist4.pdf">
                                    Grade 4
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist5.pdf">
                                    Grade 5
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist6.pdf">
                                    Grade 6
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist7.pdf">
                                    Grade 7
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist8.pdf">
                                    Grade 8
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist9.pdf">
                                    Grade 9
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist10.pdf">
                                    Grade 10
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist11.pdf"> Grade 11 <i class="bi bi-file-pdf"></i> </a>
                            </li>
                       <li>
                                <a target="_blank" rel="noreferrer" href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/booklist12.pdf">
                                    Grade 12
                                    <i class="bi bi-file-pdf"></i>
                                </a>
                            </li>
                            </ul>
                    </div>
                  
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Booklist